// จำรหัสลิงก์ส่วนตัวของแม่บ้าน (?t=) ไว้ในเครื่อง
// การ์ดในกลุ่มไลน์ (เช่น คืนเงินประกัน /once/cleaner?view=deposit-manage&d=) ลิงก์ไม่มี t
// -> ใช้รหัสที่เคยเปิดลิงก์ส่วนตัวไว้แทน · localStorage อาจใช้ไม่ได้ (private mode) -> แค่ไม่จำ
const KEY = 'once_cleaner_token';

export const NO_TOKEN_MESSAGE = 'เปิดลิงก์ส่วนตัวของคุณจากไลน์ก่อน 1 ครั้ง แล้วกดลิงก์นี้อีกครั้ง';

export const getCleanerToken = () => {
  const t = new URLSearchParams(window.location.search).get('t');
  if (t) {
    try { window.localStorage.setItem(KEY, t); } catch (e) { /* ignore */ }
    return t;
  }
  try { return window.localStorage.getItem(KEY) || null; } catch (e) { return null; }
};

// เปลี่ยน/ลบ query param โดยไม่รีโหลดหน้า (null = ลบ)
export const setUrlParams = (params) => {
  try {
    const q = new URLSearchParams(window.location.search);
    Object.entries(params).forEach(([k, v]) => { if (v === null || v === undefined || v === '') q.delete(k); else q.set(k, v); });
    window.history.replaceState(null, '', `${window.location.pathname}?${q.toString()}`);
  } catch (e) { /* ignore */ }
};
